import React from "react";
import { ReactComponent as PluginSvg } from "@assets/icons/card_setting.svg";
import { createRow, createColumn, createText, createBlock } from "@whalecloud/page-builder-core/utils/elementUtils";
import CardElement from "./components/CardElement";
import CardSetting from "./components/CardSetting";
import { getLocale } from '@utils/util';

const createChildren = () => {
  const cardHeader = createText({ data: { text: 'title' }});
  // cardHeader.data.text = '<p>title</p>';
  // cardHeader.data.settings.margin.desktop.bottom = 0;
  const cardBody = createBlock({
    elements: [
      createRow({
        elements: [
          createColumn(),
        ],
      }),
    ],
  });
  return [cardHeader, cardBody];
};

export default () => {
  const messages = getLocale();
  
  return {
    name: 'card', // 插件名，不能包含空格,空格用-代替
    title: messages['PAGEBUIDER_ELEMENT_PANEL'], // 插件标题
    target: ["collapse","column", "row", "form"],
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: { // 插件初始化数据
      settings: {
        visible: true,
        width: {
          value: "100%"
        },
        margin: {
          desktop: { top: 0, left: 0, right: 0, bottom: 0 },
          mobile: { all: 0 },
          advanced: true,
        },
        padding: {
          desktop: { all: 0 },
          mobile: { all: 0 },
        },
      }, // 插件样式属性
      componentSettings: {
        showArrow: false,
        bordered: true,
      },
    },
    elements: createChildren,
    pluginComponent: CardElement, // 插件组件
    pluginSettingComponent: CardSetting, // 插件设置项组件
  };
};
